'use client';

import clsx from 'clsx';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { Typography } from '@highlight-cp/core-ui';

import classes from './markdown-prose.module.css';
import markdown from './markdown-map';

export interface MarkdownProseProps {
  /** The markdown source to render. */
  children: string;
  /** Extra class on the Typography root, for per-surface tuning (e.g. a chat column's base size). */
  className?: string;
}

/**
 * ### MarkdownProse
 *
 * @description
 * The one place model-written markdown becomes styled prose. Renders `react-markdown` (+
 * `remark-gfm`) inside Mantine `Typography`, which styles the native HTML that markdown emits —
 * headings, lists, tables, code, blockquotes — through its `@layer mantine` rules. The `markdown`
 * map keeps only the two behavioural overrides (external links, heading-level shifting); everything
 * presentational is Typography plus the scoped `markdown-prose.module.css` tuning a chat column
 * needs.
 *
 * Every answer surface (Insights chat, the Results recommendations summary, the feasibility IR
 * reasoning) shares this, so prose reads the same everywhere and a design change lands in one place.
 */
export const MarkdownProse = ({ children, className }: MarkdownProseProps) => (
  <Typography className={clsx(classes.prose, className)}>
    <Markdown remarkPlugins={[remarkGfm]} components={markdown}>
      {children}
    </Markdown>
  </Typography>
);
